import React from 'react';
import ReactDOM from 'react-dom';
import appStore from 'common/stores/app-store';
import {reactDOMInject} from 'common/utils/dom-util';
import StoryboardApp from 'storyboard/app';
import reducer from 'storyboard/reducers/storyboard-reducer';

import './index.scss';

const storeProps = {
  enums: window.enums,
  report: {},
  settings: window.settings,
};

reactDOMInject(StoryboardApp, '#app', (attributes) => {
  const store = appStore(reducer, {
    ...storeProps,
    dashboards: JSON.parse(attributes.dashboards),
    data: JSON.parse(attributes.data),
  });
  return {store};
});
